var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSignatureStrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13H3.41L2 11.59V6H10V11L12 9V5L11 4H10V2L9.71 1.29L8.71 0.29L8 0H4L3.29 0.29L2.29 1.29L2 2V4H1L0 5V12L0.29 12.71L2.29 14.71L3 15H6L8 13ZM4 2.41L4.41 2H7.58L7.99 2.41V4H3.99V2.41H4ZM6 7.5C6.83 7.5 7.5 8.17 7.5 9C7.5 9.83 6.83 10.5 6 10.5C5.17 10.5 4.5 9.83 4.5 9C4.5 8.17 5.17 7.5 6 7.5ZM20.47 11.76L9.88 22.35L9.49 22.59L5.26 24L4 22.74L5.41 18.51L5.65 18.12L16.24 7.54L17.65 8.95L7.23 19.37L6.52 21.49L8.64 20.78L19.06 10.36L20.47 11.77V11.76ZM14 22H24V24H14V22ZM24 6.82V8.23L21.88 10.35L20.47 8.94L21.88 7.53L20.47 6.12L19.06 7.53L17.65 6.12L19.77 4H21.18L24 6.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignatureStrong);
export default __webpack_public_path__ + "static/1788088179/media/icon-signature-strong.99a9d4350b262e7d0182c4ea18a5a0a0.svg";
export { ForwardRef as ReactComponent };